<mat-sidenav-container class="sidenav-container ">
  <mat-sidenav-content>
    <mat-toolbar class="navbar">
      <a class="navbar-brand" href="/">
        <img width="70px" src="../../../../assets/images/logo _Mrv_Pag_Novo.png" />
      </a>
      <button class="navbar-end" mat-button (click)="logout()" color="warn" matTooltip="Realizar Logout">
        <label class="align-rigth label colored-orange">
          MRVBH/
          <label class="align-rigth label colored-gray">{{currentUser.login}}</label>
        </label>
      </button>
    </mat-toolbar>
  </mat-sidenav-content>
</mat-sidenav-container>